import moment, { Moment } from 'moment';
import { SMS_USAGE_UNKNOWN_PREFIX } from 'constants/smsUsage/smsUsage';
import { SmsUsageBusiness, SmsUsagePrefix } from 'types/smsUsage/smsUsage';

export const SMS_USAGE_DATE_FORMAT = 'YYYY-MM-DD';

/** The backend keeps today plus the previous 30 UTC days. */
export const SMS_USAGE_HISTORY_DAYS = 31;

/** A prefix at or above this share of its daily limit gets its business opened on load. */
export const SMS_USAGE_ATTENTION_PERCENT = 80;

export const getSmsUsageToday = (now: Moment = moment.utc()): string =>
  now.clone().utc().format(SMS_USAGE_DATE_FORMAT);

export const getSmsUsageOldestDate = (today: string): string =>
  moment
    .utc(today, SMS_USAGE_DATE_FORMAT)
    .subtract(SMS_USAGE_HISTORY_DAYS - 1, 'days')
    .format(SMS_USAGE_DATE_FORMAT);

export const formatSmsUsagePrefix = (prefix: string): string =>
  prefix === SMS_USAGE_UNKNOWN_PREFIX ? 'Unknown' : `+${prefix}`;

export const getSmsUsageBusinessKey = ({ businessId }: Pick<SmsUsageBusiness, 'businessId'>) =>
  businessId === null ? 'unknown' : String(businessId);

export const getHighestUsagePercent = (prefixes: SmsUsagePrefix[]): number | null =>
  prefixes.length ? Math.max(...prefixes.map(({ usagePercent }) => usagePercent)) : null;

export const needsSmsUsageAttention = ({
  blocked,
  prefixes,
}: Pick<SmsUsageBusiness, 'blocked' | 'prefixes'>) =>
  blocked ||
  prefixes.some((prefix) => prefix.blocked || prefix.usagePercent >= SMS_USAGE_ATTENTION_PERCENT);
